import { apiService } from '../../../shared/services/apiServices';
import { AxiosError } from 'axios';
import technicianEndpoints from './technicianEndpoints';
import { TechnicianDetailResponse } from '../types/editTechnicianType';

/**
 * Get technician by ID for editing
 */
export const getTechnicianByIdApiService = async (
  id: string
): Promise<TechnicianDetailResponse> => {
  const url = `${technicianEndpoints.TECHNICIANS}/${id}`;

  try {
    const result = await apiService.getAPI(url);

    if (!result.error) {
      // API returns { technician: {...} }, extract the nested object
      const responseData = result.data as {
        technician: TechnicianDetailResponse;
      };
      return responseData.technician;
    } else {
      const errorData = result.data as { message?: string };
      throw new Error(errorData?.message || 'Failed to fetch technician');
    }
  } catch (error) {
    if (error instanceof AxiosError) {
      const errorMessage =
        error.response?.data?.message || 'Failed to fetch technician';
      throw new Error(errorMessage);
    }
    throw error;
  }
};
